import React from "react";

export const Input = ({
  label,
  type = "text",
  value,
  onChange,
  disabled,
  readOnly,
  placeholder,
  error,
  disabledLabel,
  ...props
}) => {
  return (
    <>
      {disabledLabel ? <span className="px-3 text-[12px] text-gray-400 right-2">{label}</span> :  <span className="px-3 text-[12px] right-2">{label}</span>}
      <input
        disabled={disabled}
        readOnly={readOnly}
        type={type}
        className={`rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm ${error ? "border-red-600" : ""}`}
        placeholder={placeholder ?? `وارد کنید`}
        onChange={(c) => onChange(c.target.value)}
        value={value}
        {...props}
      />
      {error && <p className={"text-sm mt-2 text-red-600"}>{error}</p>}
    </>
  );
};
